module.exports = __webpack_public_path__ + "static/media/Todolist.96869e7b.jpg";